/**
 * Formats a phone number for display in US style: "(123) 456-7890".
 * An 11-digit number with a leading 1 keeps its country code
 * ("+1 (123) 456-7890"). Anything else — international, partial, or with an
 * extension — is returned as typed (trimmed) so no information is lost.
 * Display only: never use the result as the value sent to the API.
 * @param {string|null|undefined} phone - Raw phone number
 * @returns {string} Formatted phone, or "" when empty
 */
export const formatPhoneUS = (phone) => {
  const trimmed = (phone || "").trim();
  const digits = trimmed.replace(/\D/g, "");

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith("1")) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  return trimmed;
};
